import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeService } from 'app/modules/home/services/home.service';
import { Subject, takeUntil } from 'rxjs';
import { AssessmentsService } from '../services/assessments.service';

@Component({
  selector: 'app-post-assessment',
  template: `
    <div></div>
  `,
  styleUrls: [],
  standalone: true,
})
export class PostAssessmentComponent implements OnInit, OnDestroy {
  public redirectTo: string | null = null;
  private assessmentToken: string = '';
  private ngDestroy$ = new Subject<void>();
  private route: ActivatedRoute = inject(ActivatedRoute);
  private homeService: HomeService = inject(HomeService);
  private router: Router = inject(Router);
  private assessmentsService: AssessmentsService = inject(AssessmentsService);

  ngOnInit() {
    this.redirectTo = localStorage.getItem('postAssessmentRedirectUrl');
    if (!this.redirectTo || this.redirectTo == '') this.router.navigate(['home'], { replaceUrl: true });
    this.route.queryParams.pipe(takeUntil(this.ngDestroy$)).subscribe({
      next: (params) => {
        if (params && params['assessmentToken']) {
          this.assessmentToken = params['assessmentToken'];
          this.redirectAfterAssessment();
        }
      },
    });
  }

  redirectAfterAssessment() {
    this.homeService
      .getUserProfile(this.assessmentToken)
      .pipe(takeUntil(this.ngDestroy$))
      .subscribe({
        next: (userProfileResp) => {
          if (userProfileResp) {
            let assessmentInstanceId = userProfileResp.userProfile.assessmentInstanceId;
            let assessmentId = userProfileResp.userProfile.assessmentId;
            this.homeService
              .updateProgramSummary(assessmentInstanceId, assessmentId)
              .pipe(takeUntil(this.ngDestroy$))
              .subscribe({
                next: (updatePSResp) => {
                  if (updatePSResp) {
                    localStorage.setItem('postAssessmentRedirectUrl', '');
                    setTimeout(() => {
                      this.assessmentsService.closeAssessment();
                    });
                    this.router.navigate([this.redirectTo], {
                      queryParams: {
                        assessmentInstanceId,
                        assessmentId,
                        questionnaireInstanceId: updatePSResp.id,
                      },
                    });
                  }
                },
              });
          }
        },
      });
  }

  ngOnDestroy(): void {
    this.ngDestroy$.next();
    this.ngDestroy$.complete();
  }
}
